module.exports = __webpack_public_path__ + "mainassets/img/chevron-down-bright.eacb9761.svg";